import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../vuex/store'

const GameList = () => import('../views/GameList')
const GameContent = () => import('../views/GameContent')
const Login = () =>import('../views/Login')
const Regist =()=>import('../views/Regist')
const PrizeWinner =()=>import('../views/PrizeWinner')

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path:'/',
        redirect:'/list'
    },

    {
        path: '/list',
        name: 'list',
        meta: {
            isLogin: true,
            title:'海南足球协会官网竞猜 '
        },
        component: GameList
    },

    {
        path: '/winner',
        name: 'winner',
        meta: {
            isLogin: true,
            title:'海南足球协会官网竞猜 '
        },
        component: PrizeWinner
    },
    {
        path: '/content',
        name: 'content',
        meta: {
            isLogin: true,
            title:'海南足球协会官网竞猜 '
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: GameContent
    },
    {
        path:'/login',
        name:'login',
        component:Login,
        meta: {
            isLogin: false,
            title:'海南足球协会官网竞猜 '
        }
    },
    {
        //注册
        path: '/regist',
        component: Regist,
        meta: {
            isLogin: false,
            title:'海南足球协会官网竞猜 '
        }
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    //获取用户登录成功后储存的登录标志
    let getId = localStorage.getItem("id");

    //如果登录标志存在且为isLogin，即用户已登录
    if(getId){
        //设置vuex登录状态为已登录
        store.state.isLogin = true
        next()


        // 如果已登录，还想想进入登录注册界面，则定向回首页
        // if (!to.meta.isLogin) {
        //     //iViewUi友好提示
        //     // alert('请先退出登录哦')
        //     next({
        //         path: '/list'
        //     })
        //
        // }

        //如果登录标志不存在，即未登录
    }
    else{
        //用户想进入需要登录的页面，则定向回登录界面
        if(to.meta.isLogin){
            next({
                path: '/login',
            })
            //iViewUi友好提示
            alert('请先登录哦')
            //用户进入无需登录的界面，则跳转继续
        }else{
            next()
        }

    }

});

router.afterEach(route => {
    window.scroll(0, 0);
});

export default router
